import React from 'react';
import {Route, Redirect} from 'react-router-dom';

/** Default route component. Used to fallback to default view */
export const DefaultRoute = () => (
    <Route>
        <Redirect to="/documents/explore" />
    </Route>
);
